module.exports = require("@getvim/components-molecules-distance-slider");